<template>
  <div>
    <Header>
      <template #title>
        {{ posTitle }}
      </template>

      <template #actions>
        <BaseButton variant="secondary" size="md" color="v1-grey-10" v-if="selected == 'iiko'">
          <a class="qrw-button-text v1-grey-10-color" href="/packages/QRWaiterIikoPlugin.zip">
            {{ $t('integrations.iiko_connect.download') }} (v.1.2.0)
          </a>
        </BaseButton>
      </template>
    </Header>
    <IQOSHorizontalScroll noScroller v-if="!forcedSystem">
       <div class="supported-integrations">
          <img
            src="/icons/poster-integration.png"
            :class="{
              selected: selected == 'poster',
            }"
            @click="selected = 'poster'"
          />
          <img
            src="/icons/iiko.png"
            :class="{
              selected: selected == 'iiko',
            }"
            @click="selected = 'iiko'"
          />
          <!-- <div
            :class="{
              'order-integration': true,
              selected: selected == 'custom',
            }"
            @click="selected = 'custom'"
          >
            +
          </div> -->
      </div>

      <template #actions>
        <BaseButton
          size="md"
          variant="secondary"
          color="v1-grey-10"
          icon="link"
          @click="connectIntegration"
          v-if="!isConnected">
            {{ $t('store_card.connect') }}
        </BaseButton>
      </template>
    </IQOSHorizontalScroll>


    <PageContainer :noTopSpace="!forcedSystem">
      <BaseDivider color="v1-grey-5" class="mt-16 mb-16" v-if="!forcedSystem"/>

      <div class="iqos-grid" v-if="selected == 'poster'">
        <div class="iqos-column" v-if="isPosterEnabled">
          <PosterImportPanel />
          <PosterSyncOptions />
        </div>
        <div class="iqos-column" v-if="isPosterEnabled">
          <PosterHealthPanel />
          <PosterSettings />
        </div>
      </div>

      <div class="iqos-grid" v-if="selected == 'iiko'">
        <div class="iqos-column">
          <IikoConnector />
          <IikoAutoSettings />
        </div>
        <div class="iqos-column">
          <IikoImportPanel v-if="isIikoActive" />
        </div>
      </div>
      <div
        class="center-container justify-content-start px-50"
        v-else-if="selected == 'custom'"
      >
        <OrderIntegration />
      </div>
    </PageContainer>
  </div>
</template>

<script>
import SupportedIntegrations from "@/components/integrations/SupportedIntegrations.vue";
import PosterIntegration from "@/components/integrations/PosterIntegration.vue";
import PosterSettings from "@/components/integrations/PosterSettings.vue";
import PosterImportPanel from "@/components/integrations/PosterImportPanel.vue";
import OrderIntegration from "@/components/integrations/OrderIntegration.vue";
import PosterSyncOptions from "@/components/integrations/PosterSyncOptions.vue";
import PosterHealthPanel from "@/components/integrations/PosterHealthPanel.vue";
import PosterInstantUI from "@/components/integrations/PosterInstantUI.vue";

import IikoConnector from "@/components/integrations/IikoConnector.vue";

import IikoImportPanel from "@/components/integrations/IikoImportPanel.vue";
import IikoAutoSettings from "@/components/integrations/IikoAutoSettings.vue";

import PosterStatus from "@/components/integrations/PosterStatus.vue";

export default {
  data() {
    return {
      selected: "poster",
      orderIntegration: false,
    };
  },
  methods: {
    connectIntegration() {
      if (this.selected == 'poster') {
         window.location.href = '/api/poster/start';
      }
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    isPosterEnabled() {
      return !!this.cafe.poster;
    },
    isIikoActive() {
      return !!this.cafe.iiko && this.cafe.iiko.front_token;
    },
    isConnected() {
      if (this.selected == 'poster') return this.isPosterEnabled;
      if (this.selected == 'iiko') return this.isIikoActive;

      return false;
    },
    forcedSystem() {
      return this.$route.params.id;
    },
    posTitle() {
      return {
        poster: 'Poster',
        iiko: 'iiko'
      }[this.selected];
    }
  },
  mounted() {
    if (this.forcedSystem) this.selected = this.forcedSystem;
  },
  components: {
    SupportedIntegrations,
    PosterIntegration,
    PosterSettings,
    PosterStatus,
    PosterImportPanel,
    OrderIntegration,
    IikoConnector,
    IikoImportPanel,
    PosterSyncOptions,
    PosterHealthPanel,
    PosterInstantUI,
    IikoAutoSettings
  },
};
</script>

<style scoped>
/* .integrations-wrapper {
  padding: 5.6vh 5.6vh 0 40vh;
  color: white;
  width: 100%;
} */

.pb-0 {
  padding-bottom: 0;
}

.poster-block {
  align-items: flex-start;
  display: flex;
}

.supported-integrations {
  display: flex;
  width: 100%;
  height: 12.5vh;
}

.supported-integrations img {
  width: auto;
  height: 12vh;
  cursor: pointer;
  border-radius: 0.8vh;
  border: 2px solid transparent;
  margin-right: 2.3vh;
  object-fit: cover;
  opacity: 0.4;
}

.supported-integrations img:last-child {
  margin-right: 40px;
}

.supported-integrations img.selected {
  opacity: 1;
}

.order-integration {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 13.7vh;
  width: 13.7vh;
  font-size: 4vh;
  margin-left: 2.3vh;
  border-radius: 0.8vh;
  border: 2px solid #a4a3a1;
  color: #a4a3a1;
  background-color: transparent;
  transition: 0.3s;
  cursor: pointer;
}

.order-integration:hover,
.order-integration.selected {
  background: #129b81;
  color: #ededed;
  border: 2px solid transparent;
}

a {
  text-decoration: none;
}
</style>
